<template>
	<div id="app">
		
		<b-navbar toggleable="lg" type="light" variant="light" style="z-index: 1000">
			<b-navbar-brand href="#">
				<b-img style="max-height: 40px" src="/logo2.png" class="pr-2"/> 
				
				<b-img style="max-height: 40px" src="/smartscope.png"/>
			</b-navbar-brand>

			<b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

			<b-collapse id="nav-collapse" is-nav>

			<!-- Right aligned nav items -->
			<b-navbar-nav v-if="loggedIn" class="ml-auto">
				<b-nav-item :to="{ name: 'Dashboard' }">Dashboard</b-nav-item>
				<b-nav-item :to="{ name: 'Images' }">Images</b-nav-item>
				<b-nav-item :to="{ name: 'Profile' }">Profile</b-nav-item>
				<b-nav-item @click="$app.logout(); loggedIn = false; $router.push({ name: 'Login' })">Sign Out</b-nav-item>				
			</b-navbar-nav>
			</b-collapse>
		</b-navbar>

		<router-view />
	</div>
</template>

<script>

export default {
	
	name: 'app',
	data() {
		return {
			loggedIn: false
		}
	},

	
	
	mounted() {
		//this.initEasyrtc();
		
		this.$app.on('authenticated', () => this.loggedIn = true);

		this.$app.authenticate()
		.then(() => this.$router.push({ name: 'Dashboard' }))
		.catch(() => this.$router.push({ name: 'Login' }));

		//this.user = this.$app.service('users').get('$userId');
    },

	methods: {
		initEasyrtc() {
			var iceServers = {
				iceServers: [
					{
						urls: 'turn:35.182.18.16:3478?transport=udp',
						credential: 'mm',
						username: 'mm'
					},
					{
						urls: 'turn:35.182.18.16:3478?transport=tcp',
						credential: 'mm',
						username: 'mm'
					}
				]
			};

			easyrtc.setIceUsedInCalls(iceServers);

			// Server URL
			easyrtc.setSocketUrl(process.env.VUE_APP_EASYRTC_URL);

			// Data listener
			//easyrtc.setPeerListener(this.onPeerData);

			// Call managers
			//easyrtc.setStreamAcceptor(this.onStreamAccept);
			//easyrtc.setOnStreamClosed(this.onStreamClose);

			easyrtc.connect(
				'microscope',
				null,
				() => console.log('Failed to connect.')
			);
		},
	}
}
</script>

<style>
#app {
	font-family: 'Avenir', Helvetica, Arial, sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	text-align: center;
	color: #2c3e50;
	background-color: lightgray;
	min-height: 100vh;
}
</style>
